export const CE_CONTENT = {
  hero: {
    kicker: 'Para empresas que já tentaram um sistema engessado',
    title: 'Seu processo não precisa se adaptar ao sistema. O sistema é que deveria se adaptar a ele.',
    subtitle:
      'Campos customizados, módulos que você liga conforme sua operação, integração via API e, quando nenhum módulo padrão resolve, desenvolvimento sob medida da sua equipe com o 77Gestão.',
    cta: 'Quero conversar sobre uma solução sob medida',
    ctaMessage: 'Quero entender como customizar o 77Gestão para o processo da minha empresa',
    urgency: 'Cada mês adaptando seu processo a um sistema genérico é um mês de operação mais lenta do que precisava ser.',
  },

  statsStrip: [
    { number: 'Campos', label: 'customizados por módulo e por empresa', icon: 'fa-solid fa-sliders' },
    { number: 'API', label: 'aberta para integrar com outros sistemas', icon: 'fa-solid fa-plug' },
    { number: 'Sob medida', label: 'para quem precisa de algo além do padrão', icon: 'fa-solid fa-puzzle-piece' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações com o sistema que você usa hoje?',
    intro:
      'Sistema de prateleira resolve o básico. O problema aparece quando o seu negócio tem uma particularidade que o "pacote fechado" não previu.',
    items: [
      { icon: 'fa-solid fa-list-check', text: 'Falta um campo ou informação específica do seu negócio no cadastro, e não tem onde colocar.' },
      { icon: 'fa-solid fa-lock', text: 'Módulos que sua empresa nunca vai usar ocupam tela e confundem a equipe, sem opção de simplesmente desligar.' },
      { icon: 'fa-solid fa-plug-circle-xmark', text: 'Seu site, aplicativo ou sistema legado não conversa com o ERP porque não existe uma porta de integração aberta.' },
      { icon: 'fa-solid fa-hourglass-half', text: 'Uma regra ou fluxo específico do seu setor não existe em nenhum sistema pronto do mercado.' },
      { icon: 'fa-solid fa-arrow-up-right-dots', text: 'A empresa cresceu e o "pacote fechado" que servia há dois anos não acompanha mais a operação atual.' },
    ],
  },

  midCta: {
    text: 'E se o sistema pudesse ter só os módulos que você usa, os campos que o seu negócio precisa, e crescer junto quando faltar alguma peça?',
    cta: 'Quero ver como funciona',
    ctaMessage: 'Quero ver uma demonstração de como o 77Gestão se adapta ao meu processo',
  },

  solution: {
    title: 'Customização em camadas — do ajuste simples ao módulo feito sob medida.',
    intro:
      'O 77Gestão foi construído para se adaptar em graus diferentes, dependendo do quanto o seu processo foge do padrão de mercado.',
    cards: [
      {
        icon: 'fa-solid fa-sliders',
        title: 'Campos customizados por módulo',
        text: 'Adicione campos específicos do seu negócio nos cadastros e telas que já existem, sem depender de uma atualização genérica do sistema.',
      },
      {
        icon: 'fa-solid fa-toggle-on',
        title: 'Módulos habilitados sob demanda',
        text: 'Ligue apenas os módulos que fazem sentido para sua operação — obras, veículos, PDV, portal do cliente — sem pagar ou lidar com o que não usa.',
      },
      {
        icon: 'fa-solid fa-plug',
        title: 'API REST documentada',
        text: 'Integre o 77Gestão com seu e-commerce, aplicativo ou sistema legado através de uma API própria, sem depender de exportação manual de planilha.',
      },
      {
        icon: 'fa-solid fa-chart-pie',
        title: 'Dashboard personalizado',
        text: 'Incorpore seu painel de BI (Power BI, Metabase ou Looker Studio) direto dentro do sistema, com os indicadores que importam para a sua gestão.',
      },
      {
        icon: 'fa-solid fa-hammer',
        title: 'Desenvolvimento de módulo sob medida',
        text: 'Quando nenhum módulo padrão resolve, nossa equipe avalia e desenvolve a funcionalidade específica para o seu processo, como projeto do plano Enterprise.',
      },
      {
        icon: 'fa-solid fa-arrow-trend-up',
        title: 'Evolução contínua',
        text: 'O sistema evolui junto com a sua operação — o que hoje é suficiente pode ganhar novas camadas de customização conforme a empresa cresce.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando o sistema se adapta à empresa, e não o contrário',
    intro:
      'Uma empresa com um processo de negociação bem específico do seu setor não encontrava nenhum sistema de mercado que representasse isso sem gambiarra em planilha paralela.',
    stats: [
      { number: 'Campos', label: 'customizados para o processo específico' },
      { number: '1 diagnóstico', label: 'para mapear o que precisava ser feito sob medida' },
      { number: 'Sem gambiarra', label: 'de planilha paralela para tapar buraco do sistema' },
    ],
    paragraphs: [
      'No diagnóstico inicial, a equipe do 77Gestão mapeou quais ajustes eram só campo customizado e configuração de módulo — resolvidos em poucos dias.',
      'A parte que realmente exigia lógica nova de negócio virou um projeto de desenvolvimento sob medida, orçado e entregue como módulo dentro do próprio sistema, e não mais uma planilha separada tentando se conectar com o ERP.',
    ],
    highlight: 'Resultado: sistema único, sem gambiarra por fora, com o processo real da empresa representado no software.',
    cta: 'Quero mapear o meu caso',
    ctaMessage: 'Vi o resultado e quero um diagnóstico de customização para minha empresa no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares de um ERP que se adapta ao seu negócio',
    items: [
      {
        icon: 'fa-solid fa-puzzle-piece',
        title: 'Flexibilidade em camadas',
        text: 'Do campo customizado ao módulo desenvolvido sob medida — você ajusta no nível que o seu processo realmente exige.',
      },
      {
        icon: 'fa-solid fa-plug',
        title: 'Abertura para integrar',
        text: 'API documentada para conectar o ERP a outros sistemas que sua empresa já usa, em vez de isolar tudo em silos.',
      },
      {
        icon: 'fa-solid fa-people-arrows',
        title: 'Parceria de longo prazo',
        text: 'Diagnóstico técnico com a equipe antes de qualquer desenvolvimento sob medida — sem prometer o que não será entregue.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas com processo fora do padrão escolhem o 77Gestão',
    items: [
      { icon: 'fa-solid fa-magnifying-glass', text: 'Diagnóstico técnico antes de qualquer proposta de customização — sem promessa vaga de "fazemos qualquer coisa".' },
      { icon: 'fa-solid fa-layer-group', text: 'Customização em camadas: campo, módulo habilitado, integração via API ou desenvolvimento sob medida, conforme a real necessidade.' },
      { icon: 'fa-solid fa-handshake', text: 'Implantação acompanhada, com a equipe entendendo o processo da empresa antes de sugerir o que customizar.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano e próximo, inclusive durante o desenvolvimento de módulos sob medida.' },
    ],
  },

  faq: {
    title: 'Perguntas comuns antes de começar',
    items: [
      {
        question: 'Isso significa que vocês desenvolvem qualquer funcionalidade que eu pedir, de graça?',
        answer:
          'Não. Desenvolvimento de módulo sob medida é um projeto avaliado e orçado, normalmente dentro do plano Enterprise ou contratado à parte. O que já vem incluso em qualquer plano é a customização de campos, a escolha de quais módulos ficam habilitados e a integração via API.',
      },
      {
        question: 'Quanto tempo leva para desenvolver uma funcionalidade sob medida?',
        answer:
          'Depende do escopo. O primeiro passo é sempre um diagnóstico técnico com a equipe para entender exatamente o que precisa ser construído, antes de qualquer prazo ou orçamento ser definido.',
      },
      {
        question: 'Preciso pedir um desenvolvimento sob medida toda vez que meu processo muda um pouco?',
        answer:
          'Na maioria das vezes não. Ajustes de campo e configuração de módulo já cobrem boa parte das mudanças de processo. O desenvolvimento sob medida entra quando é uma lógica de negócio nova que nenhum módulo padrão contempla.',
      },
      {
        question: 'Funciona para qualquer segmento ou porte de empresa?',
        answer:
          'Os módulos padrão (financeiro, vendas, estoque, fiscal) atendem a maioria dos segmentos. Para negócios com processos muito específicos, a customização sob medida é avaliada caso a caso no diagnóstico inicial.',
      },
      {
        question: 'Como funciona a primeira conversa?',
        answer:
          'Não é um formulário de autoatendimento. A equipe do 77Gestão conversa com você para entender o processo da empresa antes de indicar o que pode ser resolvido com configuração e o que exigiria um projeto sob medida.',
      },
    ],
  },

  ctaFinal: {
    title: 'Pare de adaptar sua empresa a um sistema genérico. Fale com quem pode adaptar o sistema a ela.',
    subtitle:
      'Agende um diagnóstico com a equipe e entenda, com clareza, o que já resolve com configuração e o que exigiria uma customização sob medida.',
    cta: 'Agendar diagnóstico com a equipe',
    ctaMessage: 'Quero agendar um diagnóstico de customização do 77Gestão para minha empresa',
  },

  seo: {
    title: 'ERP Customizado e Sob Medida para Empresas | 77Gestão',
    description:
      'Sistema ERP customizado: campos por módulo, integração via API e desenvolvimento sob medida quando o padrão não resolve. Agende um diagnóstico com a equipe.',
  },
};
